// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import * as Enums from '@/utils/enums';
import Storage from '@/utils/storage';
import Helper from '@/utils/helper';
import SettingsMenu from "@/components/settings/menu";
import {Flex} from "@mantine/core";
import SettingsTaskList from "@/PageComponents/Table/Component Tables/SettingsTaskList";
import { createFileRoute } from '@tanstack/react-router'



const TaskTemplateList = (props: any) => {

  const router = useRouter()

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);
  const getAccessStatus = () => {
    let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  };

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(router.replace, "/");
    }
  }, [accessStatus]);



  useEffect(() => {
    getAccessStatus();
  }, []);

  return (
    <div className="settings-container">
      <Flex>
        <SettingsMenu urlPath={router.asPath} />
        <div className="settings-card">
          <SettingsTaskList />
        </div>
      </Flex>
    </div>
  );
};

export default TaskTemplateList;

export const Route = createFileRoute('/_authenticated/settings/task/list')({ component: TaskTemplateList })
